/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Archival_Results_Winner_Not_ListedInputs */



/**
* | output |
* | --- |
* | "The winner must be one of the listed players" |
*
* @param {Err_Tournament_Archival_Results_Winner_Not_ListedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_archival_results_winner_not_listed = /** @type {((inputs?: Err_Tournament_Archival_Results_Winner_Not_ListedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Archival_Results_Winner_Not_ListedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le vainqueur doit faire partie des joueurs listés")
	if (locale === "es") return /** @type {LocalizedString} */ ("El ganador debe ser uno de los jugadores listados")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O vencedor deve ser um dos jogadores listados")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il vincitore deve essere uno dei giocatori elencati")
	return /** @type {LocalizedString} */ ("The winner must be one of the listed players")
});